// ── 출퇴근 관리 ☰ 'IP 관리' 항목 + 창 (2026-10-23) ─────────────────────────────
// 사용자: "IP 주소관리를 출퇴근관리에 넣어" — ☰ 맨 아래(예외 스케줄 등록 → 시간 설정 → 엑셀 다운로드 → IP 관리).
//   달력·직원별 상세 두 탭이 같은 항목·같은 창을 쓴다. 범위(ipScope)는 탭 화면 입구가 정한다:
//   본사 { apiBase: '/api/admin/ip-scope/hq' } · 회사 '.../company/:code' · 통합 '.../menu/:id' + allowShared.
//   ipScope 가 없으면(열쇠 없음·달력 전용 메뉴) 항목도 창도 없다.
import React, { useState } from 'react';
import IpManagementModal from '../ipmgmt/IpManagementModal';

/**
 * @param {{apiBase:string, allowShared?:boolean}|null} ipScope
 * @param {function} [onClosed] 창을 닫은 뒤(예: IP 거르기 목록 다시 불러오기)
 * @returns {{item: object|null, modal: React.ReactNode}}
 */
export function useIpMenu(ipScope, onClosed) {
  const [open, setOpen] = useState(false);
  if (!ipScope?.apiBase) return { item: null, modal: null };
  return {
    item: { key: 'ip', label: 'IP 관리', onClick: () => setOpen(true) },
    modal: (
      <IpManagementModal
        open={open}
        onClose={() => { setOpen(false); if (onClosed) onClosed(); }}
        apiBase={ipScope.apiBase}
        allowShared={ipScope.allowShared === true}
      />
    ),
  };
}
